export default "__VITE_ASSET__BV_dBVrP__"